<template>
   <div>
      <navbar-component />
      <main>
         <div
            class="relative pt-16 pb-32 flex content-center items-center justify-center min-header"
         >
            <div
               class="absolute top-0 w-full h-full bg-center bg-cover"
               :style="{
                  backgroundImage: `url(${headerImage})`,
               }"
            >
               <span
                  id="blackOverlay"
                  class="w-full h-full absolute opacity-75 bg-black"
               ></span>
            </div>

            <div class="container relative mx-auto">
               <div class="items-center flex flex-wrap">
                  <div
                     class="w-full lg:w-6/15 px-4 ml-auto mr-auto text-center"
                  >
                     <div class="pr-10">
                        <h1 class="text-white font-semibold text-5xl mb-6">
                           Your controls start with us.
                        </h1>
                        <p class="mt-4 text-lg text-blueGray-200">
                           Advanced Measurements (AMI) has built control systems
                           and instrumentation systems for over two decades.
                        </p>
                        <p class="mt-4 text-lg text-blueGray-200">
                           We have the experience and expertise to take your
                           control and monitoring systems to the next level.
                        </p>
                     </div>
                  </div>
               </div>
            </div>
            <div
               class="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden h-70-px"
               style="transform: translateZ(0)"
            >
               <svg
                  class="absolute bottom-0 overflow-hidden"
                  xmlns="http://www.w3.org/2000/svg"
                  preserveAspectRatio="none"
                  version="1.1"
                  viewBox="0 0 2560 98"
                  x="0"
                  y="0"
               >
                  <polygon
                     class="text-blueGray-200 fill-current"
                     points="2560 0 2560 100 0 100"
                  ></polygon>
               </svg>
            </div>
         </div>

         <section class="pb-20 bg-blueGray-200 -mt-24">
            <div class="container mx-auto px-4">
               <div class="flex flex-wrap">
                  <div class="lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center">
                     <div
                        class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg"
                     >
                        <div class="px-4 py-5 flex-auto">
                           <div
                              class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-red-400"
                           >
                              <i class="fas fa-award"></i>
                           </div>
                           <h6 class="text-xl font-semibold">
                              The Advanced Advantage
                           </h6>
                           <p class="mt-2 mb-4 text-blueGray-500">
                              Utilize our capable control platform to boost
                              efficiency and safety. Our FracCommand product
                              line integrates with existing controls and our
                              cloud services for optimal performance.
                           </p>
                        </div>
                     </div>
                  </div>

                  <div class="w-full md:w-4/12 px-4 text-center">
                     <div
                        class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg"
                     >
                        <div class="px-4 py-5 flex-auto">
                           <div
                              class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-lightBlue-400"
                           >
                              <i class="fas fa-cloud text-xl"></i>
                           </div>
                           <h6 class="text-xl font-semibold">
                              WaveData Cloud Service
                           </h6>
                           <p class="mt-2 mb-4 text-blueGray-500">
                              WaveData is a secure cloud-based solution for
                              operational control and remote monitoring.
                              Analytics is provided in powerful dashboards,
                              screens, forms, file repositories and reporting
                              all at your fingertips.
                           </p>
                           <a
                              href="/wavedata"
                              class="text-blue-500 hover:text-blue-700 underline"
                           >
                              Learn more...
                           </a>
                        </div>
                     </div>
                  </div>

                  <div class="pt-6 w-full md:w-4/12 px-4 text-center">
                     <div
                        class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg"
                     >
                        <div class="px-4 py-5 flex-auto">
                           <div
                              class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-emerald-400"
                           >
                              <i class="fas fa-fingerprint"></i>
                           </div>
                           <h6 class="text-xl font-semibold">
                              Control Integrations
                           </h6>
                           <p class="mt-2 mb-4 text-blueGray-500">
                              We provide custom software solutions, analytics,
                              and hardware builds, including the manufacturing
                              of custom control panels tailored to your specific
                              needs.
                           </p>
                        </div>
                     </div>
                  </div>
               </div>

               <div class="flex flex-wrap items-center mt-32">
                  <div class="w-full md:w-5/12 px-4 mr-auto ml-auto">
                     <div
                        class="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white"
                     >
                        <i class="fas fa-user-friends text-xl"></i>
                     </div>
                     <h3 class="text-3xl mb-2 font-semibold leading-normal">
                        Working with us is a pleasure
                     </h3>
                     <p
                        class="text-lg font-light leading-relaxed mt-4 mb-4 text-blueGray-600"
                     >
                        Our service team is here to help, and they actually do
                        help. Our reputation for service is beat only by our
                        actual ability to help you when you need us.
                     </p>
                     <p
                        class="text-lg font-light leading-relaxed mt-0 mb-4 text-blueGray-600"
                     >
                        Whether it is for part replacements, field problems or
                        just questions to figure out how to get something done
                        right, our service team is happy to help.
                     </p>
                  </div>

                  <div class="w-full md:w-4/12 px-4 mr-auto ml-auto">
                     <div
                        class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg bg-emerald-500"
                     >
                        <img
                           alt="..."
                           src="@/assets/img/servicesupport.png"
                           class="w-full align-middle rounded-t-lg"
                        />
                        <blockquote class="relative p-8 mb-4">
                           <svg
                              preserveAspectRatio="none"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 583 95"
                              class="absolute left-0 w-full block h-95-px -top-94-px"
                           >
                              <polygon
                                 points="-30,95 583,95 583,65"
                                 class="text-emerald-500 fill-current"
                              ></polygon>
                           </svg>
                           <h4 class="text-xl font-bold text-white">
                              Top Notch Services
                           </h4>
                           <p class="text-md font-light mt-2 text-white">
                              Dedicated customer service through installation,
                              commissioning, training, and field support.
                           </p>
                        </blockquote>
                     </div>
                  </div>
               </div>
            </div>
         </section>

         <section class="relative py-20">
            <div
               class="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
               style="transform: translateZ(0)"
            >
               <svg
                  class="absolute bottom-0 overflow-hidden"
                  xmlns="http://www.w3.org/2000/svg"
                  preserveAspectRatio="none"
                  version="1.1"
                  viewBox="0 0 2560 98"
                  x="0"
                  y="0"
               >
                  <polygon
                     class="text-white fill-current"
                     points="2560 0 2560 100 0 100"
                  ></polygon>
               </svg>
            </div>

            <div class="container mx-auto px-4">
               <div class="items-center flex flex-wrap">
                  <div class="w-full md:w-4/12 ml-auto mr-auto px-4">
                     <img
                        alt="Productive"
                        class="max-w-full rounded-lg shadow-lg"
                        src="@/assets/img/productive.png"
                     />
                  </div>
                  <div class="w-full md:w-5/12 ml-auto mr-auto px-4">
                     <div class="md:pr-12">
                        <div
                           class="text-emerald-600 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-emerald-300"
                        >
                           <i class="fas fa-rocket text-xl"></i>
                        </div>
                        <h3 class="text-3xl font-semibold">
                           Productive and Reliable
                        </h3>
                        <p
                           class="mt-4 text-lg leading-relaxed text-blueGray-500"
                        >
                           We make our products to ensure you are more
                           productive and able to focus on your own work and
                           decisions, while being able to trust your control
                           systems.
                        </p>
                        <ul class="list-none mt-6">
                           <li class="py-2">
                              <div class="flex items-center">
                                 <div>
                                    <span
                                       class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-emerald-600 bg-emerald-200 mr-3"
                                    >
                                       <i class="fas fa-fingerprint"></i>
                                    </span>
                                 </div>
                                 <div>
                                    <h4 class="text-blueGray-500">
                                       Precise and Accurate Controls
                                    </h4>
                                 </div>
                              </div>
                           </li>
                           <li class="py-2">
                              <div class="flex items-center">
                                 <div>
                                    <span
                                       class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-emerald-600 bg-emerald-200 mr-3"
                                    >
                                       <i class="fab fa-html5"></i>
                                    </span>
                                 </div>
                                 <div>
                                    <h4 class="text-blueGray-500">
                                       Ease of Use and Data Access
                                    </h4>
                                 </div>
                              </div>
                           </li>
                           <li class="py-2">
                              <div class="flex items-center">
                                 <div>
                                    <span
                                       class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-emerald-600 bg-emerald-200 mr-3"
                                    >
                                       <i class="far fa-paper-plane"></i>
                                    </span>
                                 </div>
                                 <div>
                                    <h4 class="text-blueGray-500">
                                       Analysis and AI driven insights
                                    </h4>
                                 </div>
                              </div>
                           </li>
                        </ul>
                     </div>
                  </div>
               </div>
            </div>
         </section>

         <section class="pb-20 relative block bg-blueGray-800">
            <div
               class="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
               style="transform: translateZ(0)"
            >
               <svg
                  class="absolute bottom-0 overflow-hidden"
                  xmlns="http://www.w3.org/2000/svg"
                  preserveAspectRatio="none"
                  version="1.1"
                  viewBox="0 0 2560 98"
                  x="0"
                  y="0"
               >
                  <polygon
                     class="text-blueGray-800 fill-current"
                     points="2560 0 2560 100 0 100"
                  ></polygon>
               </svg>
            </div>

            <div class="container mx-auto px-4 lg:pt-24 lg:pb-64">
               <div class="flex flex-wrap text-center justify-center">
                  <div class="w-full lg:w-6/12 px-4">
                     <h2 class="text-4xl font-semibold text-white">
                        Building something?
                     </h2>
                     <p
                        class="text-lg leading-relaxed mt-4 mb-4 text-blueGray-400"
                     >
                        Let us help, whether its a new innovative technology or
                        conventional systems, we can make it more accessible,
                        more intelligent or simply more reliable.
                     </p>
                  </div>
               </div>
               <div class="flex flex-wrap mt-12 justify-center">
                  <div class="w-full lg:w-3/12 px-4 text-center">
                     <div
                        class="text-blueGray-800 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center"
                     >
                        <i class="fas fa-medal text-xl"></i>
                     </div>
                     <h6 class="text-xl mt-5 font-semibold text-white">
                        Control Platforms
                     </h6>
                     <p class="mt-2 mb-4 text-blueGray-400">
                        Our reliable controls platform has proven itself in the
                        frac industy. Over 1500 systems deployed to the field.
                     </p>
                  </div>
                  <div class="w-full lg:w-3/12 px-4 text-center">
                     <div
                        class="text-blueGray-800 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center"
                     >
                        <i class="fas fa-poll text-xl"></i>
                     </div>
                     <h5 class="text-xl mt-5 font-semibold text-white">
                        Advanced Technologies
                     </h5>
                     <p class="mt-2 mb-4 text-blueGray-400">
                        We've expanding our control capabilities with new
                        equipment and a redesigned software platform that runs
                        on it.
                     </p>
                  </div>
                  <div class="w-full lg:w-3/12 px-4 text-center">
                     <div
                        class="text-blueGray-800 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center"
                     >
                        <i class="fas fa-lightbulb text-xl"></i>
                     </div>
                     <h5 class="text-xl mt-5 font-semibold text-white">
                        Cloud SaaS
                     </h5>
                     <p class="mt-2 mb-4 text-blueGray-400">
                        Our cloud services enhance any field operation with easy
                        remote access, data historians, reporting and AI
                        analytics.
                     </p>
                  </div>
               </div>
            </div>
         </section>
         <a name="contact"></a>
         <section
            class="relative block py-24 lg:pt-0 bg-blueGray-800"
            id="contact"
         >
            <div class="container mx-auto px-4">
               <div class="flex flex-wrap justify-center lg:-mt-64 -mt-48">
                  <div class="w-full lg:w-6/12 px-4">
                     <div
                        class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200"
                     >
                        <div class="flex-auto p-5 lg:p-10">
                           <h4 class="text-2xl font-semibold">
                              Want to work with us?
                           </h4>
                           <p
                              class="leading-relaxed mt-1 mb-4 text-blueGray-500"
                           >
                              Complete this form and we will get back to you
                              within 24 hours.
                           </p>
                           <form id="contactForm" @submit.prevent="sendMessage">
                              <div class="relative w-full mb-3 mt-8">
                                 <label
                                    class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                    for="department"
                                 >
                                    Department
                                 </label>
                                 <select
                                    id="department"
                                    name="department"
                                    v-model="formData.department"
                                    required
                                    class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                 >
                                    <option value="" disabled>
                                       Select a department
                                    </option>
                                    <option value="sales">Sales</option>
                                    <option value="parts">Parts</option>
                                    <option value="support">Support</option>
                                 </select>
                              </div>

                              <div class="mb-3 grid grid-cols-2">
                                 <div class="relative mr-2">
                                    <label
                                       class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                       for="name"
                                    >
                                       Full Name
                                    </label>
                                    <input
                                       type="text"
                                       id="name"
                                       name="name"
                                       v-model="formData.name"
                                       required
                                       class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                       placeholder="Full Name"
                                    />
                                 </div>

                                 <div class="relative">
                                    <label
                                       class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                       for="phone"
                                    >
                                       Phone
                                    </label>
                                    <input
                                       type="tel"
                                       id="phone"
                                       name="phone"
                                       v-model="formData.phone"
                                       :required="!formData.email"
                                       pattern="[0-9]{10}|[0-9]{3}-[0-9]{3}-[0-9]{4}|\([0-9]{3}\)[0-9]{3}-[0-9]{4}"
                                       class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                       placeholder="Phone (e.g. 123-456-7890)"
                                    />
                                    <small
                                       class="text-blueGray-500 mt-1 text-xs"
                                       >Either email or phone is required</small
                                    >
                                 </div>
                              </div>

                              <div class="relative w-full mb-3">
                                 <label
                                    class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                    for="email"
                                 >
                                    Email
                                 </label>
                                 <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    v-model="formData.email"
                                    :required="!formData.phone"
                                    class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    placeholder="Email"
                                 />
                              </div>

                              <div class="relative w-full mb-3">
                                 <label
                                    class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                    for="message"
                                 >
                                    Message
                                 </label>
                                 <textarea
                                    id="message"
                                    name="message"
                                    v-model="formData.message"
                                    required
                                    rows="4"
                                    class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
                                    placeholder="Type a message..."
                                 />
                              </div>
                              <div class="text-center mt-6">
                                 <button
                                    class="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                    type="submit"
                                    :disabled="sending || !isFormValid"
                                 >
                                    {{
                                       sending ? "Sending..." : "Send Message"
                                    }}
                                 </button>
                              </div>
                              <div
                                 id="formResponse"
                                 v-if="formResponse"
                                 class="mt-4 text-center"
                                 :class="{
                                    'text-green-500': formSuccess,
                                    'text-red-500': !formSuccess,
                                 }"
                              >
                                 {{ formResponse }}
                              </div>
                           </form>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      </main>
      <footer-component />
   </div>
</template>

<script>
import NavbarComponent from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";
import headerImage from "@/assets/img/industrial-engineer-programming-machine-control.jpg";

// No need to import unused images if they are not dynamically used in the component
// import team1 from "@/assets/img/team-1-800x800.jpg";
// import team2 from "@/assets/img/team-2-800x800.jpg";
// import team3 from "@/assets/img/team-3-800x800.jpg";
// import team4 from "@/assets/img/team-4-470x470.png";

export default {
   data() {
      return {
         headerImage,
         // No need to include unused image data properties
         // team1,
         // team2,
         // team3,
         // team4,
         sending: false,
         formResponse: "",
         formSuccess: false,
         formData: {
            name: "",
            email: "",
            phone: "",
            message: "",
            department: "",
         },
         // Use environment variable for the function URL
         // For Vue CLI:
         functionUrl:
            process.env.VUE_APP_CONTACT_FORM_FUNCTION_URL ||
            "https://contactformemail-gechccb7erftd0g6.canadacentral-01.azurewebsites.net/api/ContactForm?code=Ess0eudzvC6d05Lmq6bib5kHrq7byVX-CVqPg--AF7RKAzFueSEPdA==",
         // For Vite:
         // functionUrl: import.meta.env.VITE_CONTACT_FORM_FUNCTION_URL,
      };
   },
   components: {
      NavbarComponent,
      FooterComponent,
   },
   computed: {
      isFormValid() {
         // Basic validation: name and message are always required,
         // and at least one of email or phone must be present.
         // Department is now also required.
         return (
            this.formData.name.trim() !== "" &&
            this.formData.message.trim() !== "" &&
            this.formData.department.trim() !== "" &&
            (this.formData.email.trim() !== "" ||
               this.formData.phone.trim() !== "")
         );
      },
   },
   methods: {
      async sendMessage() {
         // Client-side validation: ensure at least email or phone is provided
         // This is good for immediate user feedback, but server-side validation
         // is always essential.
         if (!this.formData.email && !this.formData.phone) {
            this.formResponse =
               "Please provide either an email address or phone number.";
            this.formSuccess = false;
            return;
         }

         // Also check other required fields (name, message, department)
         if (
            !this.formData.name ||
            !this.formData.message ||
            !this.formData.department
         ) {
            this.formResponse = "Please fill in all required fields.";
            this.formSuccess = false;
            return;
         }

         this.sending = true;
         this.formResponse = ""; // Clear previous messages
         this.formSuccess = false;

         try {
            console.log("Sending request to:", this.functionUrl);
            console.log("Request payload:", {
               name: this.formData.name,
               email: this.formData.email,
               phone: this.formData.phone,
               message: this.formData.message,
               department: this.formData.department,
            });

            const response = await fetch(this.functionUrl, {
               method: "POST",
               headers: {
                  "Content-Type": "application/json",
               },
               body: JSON.stringify({
                  name: this.formData.name,
                  email: this.formData.email,
                  phone: this.formData.phone, // Pass phone number
                  message: this.formData.message,
                  department: this.formData.department,
                  // You might want to add a 'subject' field to your form and pass it here
                  // subject: this.formData.subject,
               }),
            });

            console.log("Response status:", response.status);
            console.log(
               "Response headers:",
               Object.fromEntries(response.headers.entries())
            );

            // Check if response has content before trying to parse JSON
            const contentType = response.headers.get("content-type");
            let data;

            if (contentType && contentType.includes("application/json")) {
               data = await response.json();
               console.log("Parsed JSON response:", data);
            } else {
               // Handle non-JSON responses (like empty responses or plain text)
               const textResponse = await response.text();
               console.warn("Non-JSON response received:", textResponse);

               if (response.ok) {
                  this.formResponse = "Message sent successfully!";
                  this.formSuccess = true;

                  // Clear the form only on success
                  this.formData = {
                     name: "",
                     email: "",
                     phone: "",
                     message: "",
                     department: "",
                  };
               } else {
                  this.formResponse = `Server error (${response.status}): ${
                     textResponse || "Unknown error"
                  }`;
                  this.formSuccess = false;
               }
               return;
            }

            if (response.ok && data.success) {
               // Success response
               this.formResponse = data.message || "Submission successful!";
               this.formSuccess = true;

               // Clear the form only on success
               this.formData = {
                  name: "",
                  email: "",
                  phone: "",
                  message: "",
                  department: "",
               };
            } else {
               // Error response
               this.formResponse =
                  data.message || "An error occurred. Please try again.";
               this.formSuccess = false;

               // Log debug info if available
               if (data.debug) {
                  console.error("Server debug info:", data.debug);
               }
            }
         } catch (error) {
            console.error("Error submitting form:", error);
            this.formResponse =
               "A network error occurred. Please try again later.";
            this.formSuccess = false;
         } finally {
            this.sending = false;
         }
      },
   },
};
</script>

<style>
.min-header {
   min-height: 45vh; /* 60% of the viewport height */
}

/* Add some basic styling for your status messages */
.success-message {
   color: green;
}
.error-message {
   color: red;
}
</style>